import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertsService } from 'src/app/alerts/alerts-custom.service';
import { AlertsvarService } from 'src/app/alerts/alertsvar.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-action-panel-bulk',
  templateUrl: './action-panel-bulk.component.html',
  styleUrls: ['./action-panel-bulk.component.scss']
})
export class ActionPanelBulkComponent {
  @Input() data:any
    @Output() actionStatus:EventEmitter<object> = new EventEmitter()
    @Output() isAcknowledge:EventEmitter<boolean> = new EventEmitter()
  
    constructor(
      public sharedservice:SharedService,
      public alertvarservice:AlertsvarService,
      private alertservice:AlertsService
    ){
  
    }
    
    actionPanelMetadata = {
      "title":"ANALYST ACTION PANEL",
      "bulk_labels":{"label1":"BULK OPERATIONS","label2":"CHECKED ALERT GROUPS"},
      "status_info":"Current Status",
      "action_headers":{"action":"NEXT STATUS ACTION","priority":"UPDATE PRIORITY (OPTIONAL)","reassign":"REASSIGN ANALYST","comment":"COMMENT","optional":"(OPTIONAL)","mandatory":"(MANDATORY)"},
      "action_buttons":{"cancel":"Cancel","save":"Save Action","acknowledge":"Acknowledge","clear":"Clear"},
      "action_placeholders":{"action":"Select Action","comment":"Select Comment (Optional)","priority":"Select Priority (Optional)","reassign":"Select Analyst"}
    }
  
    current_status = 0;
    leastStatus = 0;
    checkd_alerts_count = 0;
  
    action_panel = new FormGroup({
      action: new FormControl('',[Validators.required]),
      priority: new FormControl(),
      reassign: new FormControl(),
      reason: new FormControl()
    })
  
    current_action:any = {}
  
    
  
    ngOnInit(){
// console.log("===",this.data)
      this.calculateSelectedCount()
      // this.checkd_alerts_count = this.data.alert_info.dedup.length
      // this.getLeasStatus()
      
    }

    ngAfterViewInit(){
      this.action.valueChanges.subscribe((actionval)=>{
        this.resetActionPanel()
        this.getActions(actionval)
      })
    }
    dataChange(){
// console.log(this.data)
    }
  
    resetActionPanel(){
      this.priority.reset()
      this.reassign.reset()
      this.reason.reset()
    }
  
    validateReassign(){
      if(!this.isEmptyObject(this.current_action)  && this.current_action.reassign){
        this.reassign.addValidators(Validators.required)
      } else {
        this.reassign.removeValidators(Validators.required)
      }
      this.reassign.updateValueAndValidity();
    }
    cancelAction(){
      this.actionStatus.emit({"event":"cancel"});
    }
  
    saveAction(){
// console.log("action value==",this.action_panel.value)
      if(this.action_panel.valid){
        let updateObj = {...this.data.alert_info,...this.action_panel.value}
        this.actionStatus.emit({"event":"save","request":updateObj})
      }
    }
  
    get action() {
      return this.action_panel.get('action') as FormControl
    }
  
    get priority() {
      return this.action_panel.get('priority') as FormControl
    }
  
    get reassign(){
      return this.action_panel.get('reassign') as FormControl
    }
  
    get reason (){
      return this.action_panel.get('reason') as FormControl
    }
  
    isEmptyObject(obj: any): boolean {
      return !obj || Object.keys(obj).length === 0;
    }
  
  
    getActions(current_status:string){
      this.current_action = this.sharedservice.actions.actions[current_status]
      this.validateReassign()
      this.validateComment()
// console.log(this.current_action)
    }
  
    getReasons(action){
      if(action == 3){
        return [{"disp":"Select Comment (Optional)","value":""},...this.sharedservice.getreason(action)]
      }else{
        return this.sharedservice.getreason(action)
      }
      
    }

    getLeasStatus(){
      this.leastStatus = this.sharedservice.getLeastActionStatus(this.data.alert_info.dedup)
    }

    isCommentOptionalOrMandatory(){
      return this.current_action["comment"] ? this.actionPanelMetadata.action_headers.mandatory:this.actionPanelMetadata.action_headers.optional
    }

    validateComment(){
      if(this.current_action["comment"]){
        this.reason.addValidators(Validators.required);
      } else {
        this.reason.removeValidators(Validators.required);
      }
      this.reason.updateValueAndValidity();
    }

    calculateSelectedCount(){
      let count:number
      if(this.data.alert_info.hasOwnProperty('selectedAlert')) {
        this.checkd_alerts_count = this.data.alert_info['selectedAlert'].length || this.data.totalCount
        count = this.data.alert_info['selectedAlert'].length || this.data.totalCount - this.data.alert_info['exemptedAlert'].length
      } else {
        this.checkd_alerts_count =  this.data.alert_info.dedup.length
        count =this.data.totalCount - this.data.alert_info['exemptedGroups'].length
      }
      return count
    }

    getApplicableActions(){
      let arr = []

      if(this.sharedservice.getCurrentUserId() == this.alertvarservice.alertAnalystFilter.value){
        arr = this.sharedservice.getActions()
      }
      else{
        this.sharedservice.getActions().forEach(val=>{
          if(val.value == 3){
            arr.push(val)
          }
        })
      }
       return arr
    }
}
